import { render, staticRenderFns } from "./KnivesetStatusTransitionsExportForm.vue?vue&type=template&id=10597d7e&"
import script from "./KnivesetStatusTransitionsExportForm.vue?vue&type=script&lang=ts&"
export * from "./KnivesetStatusTransitionsExportForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports